"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _draftJs = require("draft-js"),
    _cryptoRandomString = _interopRequireDefault(require("crypto-random-string")),
    _AddReply = _interopRequireDefault(require("../../AddReply")),
    _Reply = _interopRequireDefault(require("./Reply"));

require("../styles/_replies.scss");

function _createSuper(Derived) {
  return function () {
    var result,
        Super = (0, _getPrototypeOf2["default"])(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var Replies = function (_Component) {
  function Replies(props) {
    var _this;

    return (0, _classCallCheck2["default"])(this, Replies), _this = _super.call(this, props), _this.replyToComment = function (_ref) {
      var userId = _ref.userId,
          name = _ref.name,
          contentData = {
        blocks: [{
          key: (0, _cryptoRandomString["default"])({
            length: 5
          }),
          text: "".concat(name),
          type: "unstyled",
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [{
            offset: 0,
            length: name.length,
            key: "one"
          }],
          data: {}
        }],
        entityMap: {
          one: {
            type: "mention",
            mutability: "SEGMENTED",
            data: {
              mention: {
                userId: userId,
                name: name
              }
            }
          }
        }
      },
          contentState = (0, _draftJs.convertFromRaw)(contentData),
          editorState = _draftJs.EditorState.createWithContent(contentState);

      _this.setState({
        editorState: editorState
      });
    }, _this.handleUpdateContent = function (editorState) {
      _this.setState({
        editorState: editorState
      });
    }, _this.clearInput = function () {
      return _this.setState({
        editorState: _draftJs.EditorState.createEmpty()
      });
    }, _this.setReplyRef = function (replyRef) {
      replyRef && (replyRef.scrollTop = replyRef.scrollHeight, _this._replyRef = replyRef);
    }, _this.state = {
      editorState: _draftJs.EditorState.createEmpty()
    }, _this;
  }

  (0, _inherits2["default"])(Replies, _Component);

  var _super = _createSuper(Replies);

  return (0, _createClass2["default"])(Replies, [{
    key: "render",
    value: function render() {
      var _this2 = this,
          _this$props = this.props,
          createReply = _this$props.createReply,
          deleteReply = _this$props.deleteReply,
          closePopover = _this$props.closePopover,
          comment = _this$props.comment,
          _this$props$comment$c = _this$props.comment.children,
          replies = void 0 === _this$props$comment$c ? [] : _this$props$comment$c,
          isReadOnly = _this$props.isReadOnly,
          resourceOrganisationId = _this$props.resourceOrganisationId,
          editorState = this.state.editorState;

      return replies.length ? _react["default"].createElement("div", {
        className: "replies-section-container"
      }, _react["default"].createElement("div", {
        className: "replies-section-container__heading"
      }, _react["default"].createElement("h2", null, "Replies (".concat(replies.length, ")")), _react["default"].createElement(_uiKit.Icon, {
        clickable: !0,
        className: "comment-popover__container__close-icon",
        name: "close",
        onClick: closePopover,
        color: "regent",
        hoverColor: "black",
        size: 15
      })), _react["default"].createElement("div", {
        className: "replies-section-container__replies-wrapper"
      }, _react["default"].createElement("div", {
        className: "replies-section-container__replies-wrapper__list",
        ref: this.setReplyRef
      }, replies.map(function (_ref2) {
        var commentId = _ref2.commentId,
            createdByUser = _ref2.createdByUser,
            content = _ref2.content,
            assetIds = _ref2.assetIds;
        return _react["default"].createElement(_Reply["default"], {
          key: commentId,
          deleteReply: deleteReply,
          replyToComment: _this2.replyToComment,
          commentId: commentId,
          assetIds: assetIds,
          createdByUser: createdByUser,
          content: content,
          parentComment: comment,
          isReadOnly: isReadOnly
        });
      })), _react["default"].createElement(_AddReply["default"], {
        createReply: createReply,
        comment: comment,
        onUpdateContent: this.handleUpdateContent,
        editorState: editorState,
        clearInput: this.clearInput,
        replyRef: this._replyRef,
        visible: !isReadOnly,
        resourceOrganisationId: resourceOrganisationId
      }))) : null;
    }
  }]), Replies;
}(_react.Component),
    _default = Replies;

exports["default"] = _default;